<template>
  <TextField v-bind="$props" class="da-tp-1" type="email" :rules="emailRules" />
</template>

<script lang="ts">
export type EmailFieldProps = TextFieldProps & {
  autocomplete?: string;
};

export type EmailFieldEvents = TextFieldEvents;
</script>

<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { StringSchema, string } from "yup";
import TextField, { TextFieldEvents, TextFieldProps } from "./TextField.vue";

const { t } = useI18n();

const props = withDefaults(defineProps<EmailFieldProps>(), {
  autocomplete: "email",
  name: "email",
});
defineEmits<EmailFieldEvents>();

const emailRules = computed<StringSchema>(() => {
  let schema = string();

  if (props.rules) {
    schema = schema.concat(props.rules);
  }

  return schema.email(t("form.field.email.invalid.format"));
});
</script>
